import React from "react";
import useNowTick from "../../../hooks/useNowTick";
import formatElapsed from "../js/formatElapsed";

// Texto "mm:ss" de una mesa. Es el unico componente que se redibuja cada segundo (ver hooks/useNowTick.js):
// la pantalla de Mesas ya no se redibuja entera por el reloj. `since` es un timestamp en ms.
export default function ElapsedClock({ since, fallback = "" }) {
  const now = useNowTick(Number.isFinite(since));
  if (!Number.isFinite(since)) return <>{fallback}</>;
  return <>{formatElapsed(Math.max(0, now - since))}</>;
}
